import type { Directive, DirectiveBinding } from "vue";

export const AppFocus: Directive = {
  mounted: (el: HTMLElement, binding: DirectiveBinding): void => {
    if (binding.value === undefined || binding.value) {
      el.focus();
    }
  },
};
